import dayjs from "dayjs";
const buildPropertyParams = (agentss, boundary) => {
  let mls_ids = [];
  let advertiser_ids = [];
  let agents = agentss && agentss.agents;
  if (agents != null && agents != {} && agents != undefined) {
    agents.map((agent) => {
      advertiser_ids = advertiser_ids.concat(agent && agent["advertiser_id"]);
      mls_ids = mls_ids.concat(
        agent.mls &&
          agent.mls.map((member) => {
            return {
              id: member && member.abbreviation,
              agent_id: member && member.member && member.member.id,
            };
          }),
      );
      mls_ids = mls_ids.concat(
        agent.mls_history &&
          agent.mls_history.map((member) => {
            return {
              id: member && member.abbreviation,
              agent_id: member && member.member && member.member.id,
            };
          }),
      );
    });
  }
  mls_ids = mls_ids.filter(function(element) {
    return element !== undefined;
  });
  var soldmls = [];
  if (mls_ids.length > 0) {
    soldmls = Array.from(new Set(mls_ids.map((s) => s.agent_id))).map((agent_id) => {
      return {
        agent_id: agent_id,
        id: mls_ids.find((s) => s.agent_id === agent_id).id,
      };
    });
  }
  var sold_params = {
    limit: 200,
    offset: 0,
    sort: [{ field: "sold_date", direction: "desc" }],
    query: {
      agents: soldmls,
      sold_date: {
        min: dayjs()
          .subtract(2, "years")
          .toISOString(),
        max: dayjs().toISOString(),
      },
    },
  };
  var sale_params = {
    query: { status: "for_sale", fulfillment_id: advertiser_ids.filter((obj) => obj) },
    offset: 0,
    limit: 200,
    sort: [{ field: "list_date", direction: "desc" }],
  };

  sold_params.query.boundary = sale_params.query.boundary = boundary && boundary;
  return [sold_params, sale_params];
};
const combineResults = (hestiaSoldData, hestiaSaleData) => {
  let responseObject = {
    properties: [],
    total_count: 0,
    total_returned: 0,
  };
  if (hestiaSoldData) {
    const hestiaSold = hestiaSoldData && hestiaSoldData && hestiaSoldData.closings_search;
    responseObject.properties = responseObject.properties.concat(hestiaSold && hestiaSold.results);
    responseObject.total_count += hestiaSold && hestiaSold.total;
    responseObject.total_returned += hestiaSold && hestiaSold.count;
  }
  if (hestiaSaleData) {
    const hestiaSale = hestiaSaleData && hestiaSaleData && hestiaSaleData.home_search;
    responseObject.properties = responseObject.properties.concat(hestiaSale && hestiaSale.results);
    responseObject.total_count += hestiaSale && hestiaSale.total;
    responseObject.total_returned += hestiaSale && hestiaSale.count;
  }
  return responseObject;
};
const uniqueProperties = (data, key) => {
  return [...new Map(data.map((x) => [key(x), x])).values()];
};
const agentProp = (agents, properties) => {
  let refined_agents = [];
  agents &&
    agents.map((agent) => {
      agent.property = [];
      let uniqueprop = [];
      properties &&
        properties.map((property) => {
          if (property && property.status == "sold") {
            let mls_id = {};
            agent.mls.length > 0 &&
              agent.mls.filter(function(e) {
                if (e.primary == true) mls_id = e.member.id;
              });
            if (mls_id == {} && agent.mls_history && agent.mls_history.length > 0) {
              agent.mls_history.filter(function(e) {
                if (e.primary == true) mls_id = e.member.id;
              });
            }
            property.source.agents.map(function(insideitem) {
              if (insideitem.agent_id == mls_id) {
                uniqueprop.push(property);
              }
            });
          } else {
            property &&
              property.advertisers.map(function(insideitem) {
                if (insideitem.fulfillment_id == agent.advertiser_id) {
                  uniqueprop.push(property);
                }
              });
          }
        });
      const uniqueAgentProperties = uniqueProperties(uniqueprop, (it) => it.property_id);
      agent.property.push(uniqueAgentProperties);
    });
  agents &&
    agents.map((agent) => {
      if (agent && agent.property && agent.property[0] && agent.property[0].length > 0) {
        refined_agents.push(agent);
      }
    });
  let agentObject = {};
  if (refined_agents.length > 0) {
    agentObject = {
      agent: refined_agents,
      propertystatus: false,
    };
  } else {
    agentObject = {
      agent: agents,
      propertystatus: true,
    };
  }
  return agentObject;
};
const buildList = (data) => {
  let list = [];
  data &&
    data.map((agent) => {
      agent &&
        agent.property[0].map((prop) => {
          list.push({
            dataId: prop && prop.property_id,
            dataListingAgent: agent.advertiser_id,
            agentDetails: agent,
            dataBuyingAgent: "",
            type: prop && prop.status == "sold" ? "recently_sold" : "for_sale",
            coordinate: {
              lat:
                prop &&
                prop.location &&
                prop.location.address &&
                prop.location.address.coordinate &&
                prop.location.address.coordinate.lat,
              lon:
                prop &&
                prop.location &&
                prop.location.address &&
                prop.location.address.coordinate &&
                prop.location.address.coordinate.lon,
            },
            agentImage: agent && agent.photo && agent.photo.href,
          });
        });
    });
  const uniqueList = uniqueProperties(list, (it) => it.dataId);
  const sliceList = uniqueList.slice(0, 200);
  return sliceList;
};
const previousLead = () => {
  return sessionStorage && sessionStorage.getItem("lead_generated") === "true" ? true : false;
};

module.exports = {
  buildPropertyParams,
  combineResults,
  agentProp,
  uniqueProperties,
  buildList,
  previousLead,
};
